module.exports = __webpack_public_path__ + "img/icon-products-magento-63.e53191cf.svg";